<app-lfsa-card [innTemplate]="eliminarEmpleado" [titulo]="'Eliminar Empleado'" [efecto]="true"
  [colapseName]="'eliminarEmpleado'" [banderaColapse]='true'></app-lfsa-card>
<ng-template #eliminarEmpleado>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row col-12">
      <div class="form-group col-md-6">
        <h5 class="letrasDanger"><b>Cédula*: </b></h5>
        <app-lfsa-input [control]="formulario.get('cedula')" [placeholder]="'Ingresar Cédula (Obligatorio)'"
          formControlName="cedula" [type]="'number'" [id]="'cedulaValida'"
          (keydown.enter)="onChangeCedula()" (keydown.tab)="onChangeCedula()">
        </app-lfsa-input>
      </div>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="empleado" [titulo]="'Empleado'" [efecto]="true" [colapseName]="'empleado'" *ngIf="mostrarCard"
  [banderaColapse]='true'></app-lfsa-card>
<ng-template #empleado>
  <div class="row col-12">
    <div class="col-md-6">
      <h5><b>Nombres:</b> {{ dataUsuario.nombres }}</h5>
    </div>
     <div class="col-md-6">
      <h5><b>Cédula:</b> {{ dataUsuario.codEmpleado }}</h5>
    </div>
  </div>
  <hr>
  <div class="row col-12">
    <div class="col-md-6">
      <h5><b>Empresa:</b> {{ dataUsuario.empresa.descripcion }} </h5>
    </div>
    <div class="col-md-6">
      <h5><b>Dirección:</b> {{ dataUsuario.direccion }}</h5>
    </div>
  </div>
  <hr>
  <div class="row col-12">
    <div class="col-md-6">
      <h5><b>Área:</b> {{ dataUsuario.dscaDepartamento }}</h5>
    </div>
    <div class="col-md-6">
      <h5><b>Cargo:</b> {{ dataUsuario.dscaCargo }}</h5>
    </div>
  </div>
  <hr>
</ng-template>

<br>
<div class="container">
  <div class="row">
    <div class="col">
      <button class="btn btn-success btn-block" (click)="nuevo()">Realizar nueva consulta</button>
    </div>
    <div class="col">
      <button class="btn btn-danger btn-block" [disabled]="cedValida"
        (click)="eliminar()">Eliminar</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col">
      <button class="btn btn-outline-danger btn-lg btn-block"
        [routerLink]="['/emp/administrador/home-emp'] ">Regresar</button>
    </div>
  </div>
</div>
<br>